module.exports = __webpack_public_path__ + "static/images/general/info_white.svg";